import { render, staticRenderFns } from "./MainGoalCard.vue?vue&type=template&id=556581d1&scoped=true"
import script from "./MainGoalCard.vue?vue&type=script&lang=js"
export * from "./MainGoalCard.vue?vue&type=script&lang=js"
import style0 from "./MainGoalCard.vue?vue&type=style&index=0&id=556581d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556581d1",
  null
  
)

export default component.exports